import { defineStore } from "pinia";
export const useStoreCommon = defineStore("UseCommon", {
    state: () => ({
        siderWidth: "160px",
        isShowSider: true
    }),
    actions: {

    },
    persist: {
        enabled: true,
    },
});
